var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSubdivision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.15943 0 0 5.15943 0 11.5C0 17.8406 5.15943 23 11.5 23C17.8406 23 23 17.8406 23 11.5C23 5.15943 17.8406 0 11.5 0ZM20.9399 11.5C20.9399 13.67 20.2028 15.6706 18.9668 17.266L5.73398 4.03324C7.32942 2.79717 9.33002 2.06011 11.5 2.06011C16.7052 2.06011 20.9399 6.29479 20.9399 11.5ZM2.06011 11.5C2.06011 9.20641 2.88416 7.10052 4.2507 5.46158L17.5384 18.7493C15.8995 20.1158 13.7959 20.9399 11.5 20.9399C6.29479 20.9399 2.06011 16.7052 2.06011 11.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSubdivision);
export default __webpack_public_path__ + "static/media/no-subdivision.4ef83a4c0b1f6f934a777f5b8b5678e3.svg";
export { ForwardRef as ReactComponent };